// extracted by mini-css-extract-plugin
export default {"cont_desc":"InfoDesc_cont_desc__NrsXs","cont_h2":"InfoDesc_cont_h2__u4wAK","card_desc":"InfoDesc_card_desc__GJhGM","card_desc_ind":"InfoDesc_card_desc_ind__YqOn3"};